import "./CourierRequestLog.css";
const CourierRequestLog = (props) => {
    return (
        <div className="nav-cntnr">
            <div className="row justify-content-center">
                <div className="order-cntnr mt-3">
                    <div className="row justify-content-center mt-3">
                        <div className="col-2 small-ord-col">
                            تاریخ لاگ:
                        </div>
                        <div className="col-2 small-ord-col">
                            {props.log.logDate}
                        </div>
                        <div className="col-2 small-ord-col">
                            ساعت لاگ:
                        </div>
                        <div className="col-2 small-ord-col">
                            {props.log.logTime}
                        </div>
                        <div className="col-2 small-ord-col">
                            سرویس:
                        </div>
                        <div className="col-2 small-ord-col">
                            {props.log.url}
                        </div>
                    </div>
                    <div className="row justify-content-center mt-3">
                        <div className="col-2 small-ord-col">
                            خطا:
                        </div>
                        <div className="col-2 small-ord-col">
                            {props.log.exception}
                        </div>
                        <div class="col-2 small-ord-col">
                            کاربر:
                        </div>
                        <div class="col-6 small-ord-col">
                            {props.log.user}
                        </div>
                    </div>
                    <div className="row justify-content-center mt-3">
                        <div className="col-2 small-ord-col">
                            درخواست:
                        </div>
                        <div class="col-10 small-ord-col">
                            {props.log.request}
                        </div>
                    </div>
                    <div className="row justify-content-center mt-3">
                        <div className="col-2 small-ord-col">
                            پاسخ:
                        </div>
                        <div className="col-10 small-ord-col">
                            {props.log.response}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CourierRequestLog;